






































import 'reflect-metadata'
import { Component, Watch, Mixins } from 'vue-property-decorator'
import Loader from '@/components/misc/Loader.vue'
import AssetSummary from '@/components/Asset/AssetSummary.vue'
import TransactionSummary from '@/components/Transaction/TransactionSummary.vue'
import Tooltip from '@/components/rows/Tooltip.vue'
import { Transaction } from '../js/Transaction'
import { Asset } from '@/js/Asset'
import { getTransaction, ITransactionParams } from '@/services/transactions'
import { getAssetInfo } from '@/services/assets'
import TxHeader from '@/components/Transaction/TxHeader.vue'
import TxInteractive from '@/components/Transaction/TxInteractive.vue'
import { TransactionsGettersMixin } from '@/store/modules/transactions/transactions.mixins'
import HTTPError from '@/components/misc/HTTPError.vue'
import { P, X, C } from '@/known_blockchains'

@Component({
    components: {
        Loader,
        AssetSummary,
        TransactionSummary,
        Tooltip,
        TxHeader,
        TxInteractive,
        HTTPError,
    },
})
export default class AssetPage extends Mixins(TransactionsGettersMixin) {
    loading = false
    genesisTx: Transaction | null = null
    // txs
    txLoading = false
    txRequestError = false
    txRequestErrorStatus: number | null = null
    txRequestErrorMessage: string | null = null
    filters: string[] = []
    initialParams = {
        sort: 'timestamp-desc',
        limit: 25,
    }

    created() {
        this.getData(this.initialParams)
    }

    @Watch('txId')
    ontxIdChanged() {
        this.getData(this.initialParams)
    }

    @Watch('assetsLoaded')
    onAssetsLoaded() {
        this.getData(this.initialParams)
    }

    get assetsLoaded() {
        return this.$store.state.assetsLoaded
    }

    get breadcrumbs(): any[] {
        return [
            {
                text: 'Home',
                disabled: false,
                href: '/',
            },
            {
                text: 'Assets',
                disabled: false,
                href: '/assets',
            },
            {
                text: `${
                    this.asset
                        ? this.asset.symbol
                            ? this.asset.symbol
                            : this.asset.id
                        : 'Asset'
                }`,
                disabled: true,
                href: '',
            },
        ]
    }

    get assetID(): string {
        return this.$route.params.id
    }

    get asset(): Asset {
        return this.$store.state.assets[this.$route.params.id]
    }

    get txId(): string {
        return this.$route.params.id
    }

    get chains() {
        return [P, X, C]
    }

    get transactions() {
        return this.getTxsByAsset()
    }

    getData(params: ITransactionParams): void {
        this.loading = true
        this.txLoading = true

        if (this.assetsLoaded) {
            // Get address details and genesis tx
            Promise.all([getTransaction(this.txId), getAssetInfo(this.txId)])
                .then(([transactionInfo, assetInfo]) => {
                    return {
                        ...transactionInfo,
                        ...assetInfo,
                    }
                })
                .then((data) => {
                    this.loading = false
                    this.genesisTx = new Transaction(data)
                })
                .catch((err) => {
                    this.loading = false
                    console.log(err)
                })

            this.fetchTx(params)
        }
    }

    async fetchTx(params: ITransactionParams) {
        this.txLoading = true
        this.$store
            .dispatch('Transactions/getTxsByAsset', {
                id: null,
                params: {
                    assetID: this.assetID,
                    chainID: [P.id, C.id, X.id],
                    ...params,
                },
            })
            .then(() => (this.txLoading = false))
            .catch((err) => {
                this.txLoading = false
                if (err.response) {
                    console.log(err.response)
                    this.txRequestError = true
                    this.txRequestErrorStatus = err.response.status
                    this.txRequestErrorMessage = err.response.data.message
                }
            })
    }
}
